import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as moment from 'moment';

import { LoaderEvent } from '../../shared/message.event';

import { AccountService } from '../../account/account.service';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';


@Component({
	selector: 'manualInvoicePayment-modal',
	templateUrl: './manualInvoice-payment.component.html',
	styleUrls: ['./manualInvoice-payment.component.css'],
	providers: [LoaderEvent],
	exportAs: 'manualInvoicePayment'
})
export class ManualPaymentInvoice implements OnInit {
	private utilityFunctions = new UtilityFunctions();
	@Output() refreshPage = new EventEmitter<boolean>();
	@ViewChild('childModal') childModal: ModalDirective;
	ngOnInit() {
	}

	constructor(private loaderEvent: LoaderEvent, private accountService: AccountService) {

	}
	private invoiceForPayment;
	private vendorInfo = {
		vendorId: '',
		clubName: '',
		timezoneOffset: ''
	}
	showChildModal(invoiceForPayment, vendorInfo) {
		this.vendorInfo = vendorInfo;
		this.invoiceForPayment = invoiceForPayment;
		console.log(this.invoiceForPayment);
		this.childModal.config.backdrop = false;
		this.childModal.config.keyboard = false;
		this.utilityFunctions.setBackGroundBlack();
		this.childModal.show();
	}
	public hideChildModal(): void {
		this.utilityFunctions.removeBackGroundBlack();
		this.childModal.hide();
	}


	makePayment() {
		let reqObj = {
			'penaltyId': this.invoiceForPayment._id,
			'userId': this.invoiceForPayment.paymentPendingMembers,
			'paymentDoneAt': moment(new Date()).utcOffset(this.vendorInfo.timezoneOffset),
			'payAt': 'vendor',
			'vendorId': this.vendorInfo.vendorId,
			'clubName': this.vendorInfo.clubName
		};
		this.loaderEvent.fire(false);
		this.accountService.manualInvoicePayment(reqObj).then((result: any) => {
			this.loaderEvent.fire(true);
			this.hideChildModal();
			if (result.status == 'SUCCESS') {
				this.refreshPage.emit(true);
				this.hideChildModal();
			} else {
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/account/manualInvoice-payment/manualInvoice-payment.component.ts